module.exports = __webpack_public_path__ + "static/img/POUSSE-PORTE-ANTI-BACTERIEN.49050c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/produits/POUSSE-PORTE-ANTI-BACTERIEN.jpg
// module id = mYFN
// module chunks = 0